import React, { FC, useEffect, useState } from 'react'
import { useHistory, useRouteMatch } from 'react-router-dom'

import { withProcedureWraper } from '..'
import { Routes } from '../../../AppRoutes'
import { Box } from '../../../components/box'
import { Icon } from '../../../components/icon'
import { getDiffDay, getHHmmFormat } from '../../../helper/dateTimeHelper'
import { getLocaleKey } from '../../../languages'
import { Button } from '../../../modules/button'
import { Message } from '../../../modules/message'
import { EventsService } from '../../../services/events/events.service'

export const ProcedureMeetingDetailPage: FC = withProcedureWraper(() => {
  const history = useHistory();
  const [data, setData] = useState(null as any);
  const { id } = useRouteMatch().params as any;
  const [errorMessage, setErrorMessage] = useState(null as any);

  const cancelEvent = () => {
    EventsService.cancelEvent(id)
      .then(res => {
        history.push(Routes.procedureMeeting.path)
      })
      .catch(err => setErrorMessage(err.message));
  }

  useEffect(() => {
    EventsService.getEventById(id)
      .then(res => {
        setData(res);
      })
      .catch(err => setErrorMessage(err.message));
  }, [id])

  return (
    <div className="MeetingDetailPage pd15">
      <div className="PageHead">
        <div className="title">
          <div className="btnBack" onClick={() => history.push(Routes.procedureMeeting.path)}>
            <Icon.ArrowLeft />
          </div>
          Chi tiết cuộc họp
        </div>
        <div className="d-flex">
          <div className="px-1">
            <Button
              buttonType="info"
              label="Chỉnh sửa"
              onClick={() => history.push(Routes.procedureMeetingCreate.path.replace(':id', id))}
            />
          </div>
          <div className="px-1">
            <Button
              buttonType="danger"
              label="Hủy cuộc họp"
              onClick={cancelEvent}
            />
          </div>
        </div>
      </div>
      {(() => {
        if (!data) return <Message type="loading" />
        if (errorMessage) return <Message type="error" message={errorMessage} />

        return (
          <div className="row">
            <div className="col">
              <Box title="Thông tin">
                <div className="TableInformation">
                  <table>
                    <tbody>
                      <tr>
                        <td>Thời gian</td>
                        <td>
                          {new Date(data.start.dateTime).toLocaleDateString(getLocaleKey())} | {data.isAllDay ? `Cả ngày | ${getDiffDay(data.start.dateTime, data.end.dateTime)} ngày` : `${getHHmmFormat(data.start.dateTime)} - ${getHHmmFormat(data.end.dateTime)}`}
                        </td>
                      </tr>

                      <tr>
                        <td>Nội dung chính</td>
                        <td>{data.subject}</td>
                      </tr>

                      <tr>
                        <td>Tham gia</td>
                        <td>
                          {data.attendees.map((attendee: any, attendeeKey: number) => {
                            return (
                              <div className="item" key={attendeeKey}>
                                • {attendee.emailAddress.name}
                              </div>
                            )
                          })}
                        </td>
                      </tr>
                      <tr>
                        <td>Địa điểm</td>
                        <td>
                          {data.location.displayName}
                        </td>
                      </tr>
                      <tr>
                        <td>Nội dung</td>
                        <td>
                          <div className="pd15" dangerouslySetInnerHTML={{ __html: data.body.content }} />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Box>
            </div>
          </div>
        )
      })()}
    </div>
  )
})